class EventHandler {
  constructor() {
    this.list = [];
  }

  emit(...args) {
    const type = Array.prototype.shift.call(args);
    const { list } = this;
    const fnList = list[type];
    if (!fnList || fnList.length === 0) return;
    fnList.forEach((fn) => {
      fn(...args);
    });
  }

  on(type, fn, one = false) {
    let originalFn = fn;
    const { list } = this;
    if (!list[type]) {
      list[type] = [];
    }
    // 只触发一次
    if (one) {
      originalFn = (...args) => {
        const originalType = Array.prototype.shift.call(args);
        this.off(originalType);
        return fn.apply(this, args);
      };
    }
    list[type].push(originalFn);
    return fn;
  }

  once(type, fn) {
    return this.on(type, fn, true);
  }

  off(type, fn) {
    const { list } = this;
    const fnList = list[type];
    if (!fnList || fnList.length === 0) return;
    const eventIndex = fnList.findIndex(item => item.fn === fn);
    fnList.splice(eventIndex, 1);
  }
}

export default EventHandler;
